/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolunteerSearchResult
 */
export interface VolunteerSearchResult {
    /**
     * 
     * @type {string}
     * @memberof VolunteerSearchResult
     */
    volunteerId: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerSearchResult
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerSearchResult
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerSearchResult
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolunteerSearchResult
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolunteerSearchResult
     */
    phone: string | null;
}

/**
 * Check if a given object implements the VolunteerSearchResult interface.
 */
export function instanceOfVolunteerSearchResult(value: object): value is VolunteerSearchResult {
    if (!('volunteerId' in value) || value['volunteerId'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function VolunteerSearchResultFromJSON(json: any): VolunteerSearchResult {
    return VolunteerSearchResultFromJSONTyped(json, false);
}

export function VolunteerSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolunteerSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'volunteerId': json['volunteerId'],
        'username': json['username'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'email': json['email'],
        'phone': json['phone'],
    };
}

export function VolunteerSearchResultToJSON(json: any): VolunteerSearchResult {
    return VolunteerSearchResultToJSONTyped(json, false);
}

export function VolunteerSearchResultToJSONTyped(value?: VolunteerSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'volunteerId': value['volunteerId'],
        'username': value['username'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'email': value['email'],
        'phone': value['phone'],
    };
}

